//Action creator with callback function
export function addWebDataCollection(webDataCollection) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_WEB_DATA_COLLECTION',
                payload: webDataCollection
            });
            resolve(true)
        });
    }
};

export function addGuestWebDataCollection(webDataCollection) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_GUEST_WEB_DATA_COLLECTION',
                payload: webDataCollection
            });
            resolve(true)
        });
    }
};

export const removeFullfilmentMessageURL = () => ({
    type: 'REMOVE_FULLFILMENT_URL'
});



export const resetWebDataCollection = () => ({
    type: 'RESET_WEB_DATA_COLLECTION'
});